import { type GroupOrderJoinPreviewQuery } from '../graphql/GroupOrderJoin.generated';

// ─────────────────────────────────────────────────────────────────────────────

export function getPreviewErrorMessage(params: GetPreviewErrorMessageParams) {
  const { preview } = params;

  const typename = preview?.__typename;

  if (typename === 'MultipartyOrderNotFound' || typename === 'OrderLocked') {
    return preview?.errorMessage;
  }
}

// ─── Types ───────────────────────────────────────────────────────────────────

type GroupOrderPreview = GroupOrderJoinPreviewQuery['multipartyOrderPreview'];
type GetPreviewErrorMessageParams = { preview: GroupOrderPreview | undefined };
